import React from 'react';
import ReactDOM from 'react-dom';
import CounterApp from './components/CounterApp';
import 'normalize.css/normalize.css';
import './styles/styles.scss';

ReactDOM.render( <CounterApp />, document.getElementById( 'app' ) );


// WEBPACK FOOTER //
// ./src/app.js